<template>
    <w-flex class="mt2" wrap align-center justify-end>
        <div class="spacer" />

        <w-button
            class="my1 mr2"
            @click="printExcel1()"
            :loading="loading"
            v-if="printExcel"
            :disabled="items.length == 0"
        >
            <i class="fal fa-file-alt mr2" style="font-size: 11px"></i>Senarai
        </w-button>
        <w-button
            class="my1 mr2"
            @click="printWarta($page.props.auth.user.jabatan_id)"
            :loading="loading"
            v-if="urlWarta"
            :disabled="checkSelect.length == 0"
        >
            <i class="fal fa-print mr2" style="font-size: 11px"></i>Cetak Surat
            Warta
        </w-button>
        <!-- <w-button
            class="my1 mr2"
            @click="print($page.props.auth.user.jabatan_id)"
            :loading="loading"
            v-if="printUrl"
            :disabled="checkSelect.length == 0"
        >
            <i class="fal fa-print mr2" style="font-size: 11px"></i>Cetak
        </w-button> -->

        <w-menu v-if="printUrl" hide-on-menu-click>
            <template #activator="{ on }">
                <w-button v-on="on" :disabled="checkSelect.length == 0" class="mr3"><i class="fal fa-print mr2" style="font-size: 11px"></i> Cetak </w-button>
            </template>
            <w-button
                class="my1 mr2"
                @click="print($page.props.auth.user.jabatan_id,true)"
                :loading="loading"
                v-if="printUrl"
                :disabled="checkSelect.length == 0"
            >
                <i class="fal fa-print mr2" style="font-size: 11px"></i>Tahun Semasa
            </w-button>
            <w-button
                class="my1 mr2"
                @click="print($page.props.auth.user.jabatan_id)"
                :loading="loading"
                v-if="printUrl"
                :disabled="checkSelect.length == 0"
            >
                <i class="fal fa-print mr2" style="font-size: 11px"></i>Keseluruhan
            </w-button>
        </w-menu>

        <w-menu v-if="enforceUrl || reenforceUrl" hide-on-menu-click>
            <template #activator="{ on }">
                <w-button v-on="on" class="mr3"> Jana Notis </w-button>
            </template>
            <w-button
                class="my1 mr2"
                @click="reenforce()"
                :loading="loading"
                v-if="reenforceUrl"
                :disabled="checkSelect.length == 0"
            >
                <i class="fal fa-repeat mr2" style="font-size: 11px"></i>
                Ulang Jana {{ label }}
            </w-button>
            <w-button
                class="my1 mr2"
                @click="enforce()"
                :disabled="checkSelect.length == 0"
                :loading="loading"
                v-if="enforceUrl"
            >
                <i class="fal fa-exclamation mr2" style="font-size: 11px"></i>
                Jana {{ label2 }}
            </w-button>
            <w-button
                class="my1 mr2"
                @click="enforce2()"
                :disabled="checkSelect.length == 0"
                :loading="loading"
                v-if="enforceUrl2"
            >
                <i class="fal fa-exclamation mr2" style="font-size: 11px"></i>
                Jana {{ label4 }}
            </w-button>
        </w-menu>
    </w-flex>
</template>
<script>
import { Inertia } from "@inertiajs/inertia";
export default {
    props: {
        items: [Object, Array],
        checkSelect: [Object, Array],
        searchParams: Object,
        label: {
            default: null,
            type: String,
        },
        label2: {
            default: null,
            type: String,
        },
        label3: {
            default: null,
            type: String,
        },
        label4: {
            default: null,
            type: String,
        },
        enforceUrl: {
            default: null,
            type: String,
        },
        enforceUrl2: {
            default: null,
            type: String,
        },
        enforceUrl3: {
            default: null,
            type: String,
        },

        reenforceUrl: {
            default: null,
            type: String,
        },
        printUrl: {
            default: null,
            type: String,
        },
        urlWarta: {
            default: null,
            type: String,
        },
        printExcel: {
            default: null,
            type: String,
        },
    },
    emits: ["onDoneEnforce"],
    data() {
        return {
            resourceurl: "cukai-tanah",
            reload: true,
            loading: false,
            _uid: [
                {
                    id: null,
                },
            ],
        };
    },
    methods: {
        async enforce() {
            this.$emit("onDoneEnforce");

            this.loading = true;
            // console.log(this.checkSelect);
            await axios({
                method: "post",
                url: `${this.enforceUrl}`,
                responseType: "json",
                data: this.checkSelect,
            })
                .then((e) => {
                    this.$waveui.notify({
                        success: true,
                        message: `Berjaya! ${this.label2} telah dijana.`,
                        timeout: 3000,
                    });
                    this.$emit("onDoneEnforce");
                })
                .catch((e) => {
                    this.$waveui.notify({
                        error: true,
                        message: `Ralat`,
                        timeout: 3000,
                    });
                })
                .finally(() => {
                    this.loading = false;
                    // this.checkSelect = [];
                });
        },
        async enforce2() {
            this.$emit("onDoneEnforce");

            this.loading = true;
            // console.log(this.checkSelect);
            await axios({
                method: "post",
                url: `${this.enforceUrl2}`,
                responseType: "json",
                data: this.checkSelect,
            })
                .then((e) => {
                    this.$waveui.notify({
                        success: true,
                        message: `Berjaya! ${this.label4} telah dijana.`,
                        timeout: 3000,
                    });
                    this.$emit("onDoneEnforce");
                })
                .catch((e) => {
                    this.$waveui.notify({
                        error: true,
                        message: `Ralat`,
                        timeout: 3000,
                    });
                })
                .finally(() => {
                    this.loading = false;
                    // this.checkSelect = [];
                });
        },
        async reenforce() {
            this.loading = true;
            await axios({
                method: "post",
                url: `${this.reenforceUrl}`,
                responseType: "json",
                data: this.checkSelect,
            })
                .then((e) => {
                    this.$waveui.notify({
                        success: true,
                        message: `Berjaya! ${this.label} telah di ulang dijana.`,
                        timeout: 3000,
                    });
                })
                .catch((e) => {
                    this.$waveui.notify({
                        error: true,
                        message: `Ralat.`,
                        timeout: 3000,
                    });
                })
                .finally(() => {
                    this.loading = false;
                    this.$emit("onDoneEnforce");
                });
        },
        async print($x,$semasa=false) {
            const x = this.checkSelect.map((e) => e.id);
            const y = this.checkSelect.map((e) => e.notis_id);
            // console.log($x);
            const w= $x;
            if($semasa == true){
                var semasa = '&semasa=true';
            } else {
                var semasa = '';
            }
            if(this.searchParams.tahun != null){
                var tahun = `&tahun=${this.searchParams.tahun}`;
            } else {
                var tahun = '';
            }
            await axios({
                method: "get",
                url: `${this.printUrl}?notis_id=[${y}]&jabatan=${w}${semasa}${tahun}&checking=true`,
                responseType: "json",
            })
                .then((e) => {
                    console.log(e)
                    if(e.data == 0){
                        this.$waveui.notify({
                            success: false,
                            message: `No. Hak Milik tiada Notis Tahun Semasa.`,
                            timeout: 3000,
                        });
                    } else {
                        window.open(`${this.printUrl}?notis_id=[${y}]&jabatan=${w}${semasa}${tahun}`, "_blank");
                    }
                    this.loading = false;
                });

            
            
        },
        async printExcel1() {
            if (this.searchParams.nama == null) {
                delete this.searchParams.nama;
            }
            // this.searchParams.jenis = this.label;
            this.searchParams.notis = this.label3;
            
            if(this.checkSelect != null)
                var ids = this.checkSelect.map((e) => e.id);
            if(ids != null && ids.length > 0){
                var id_selected = `&ids=[${ids}]`;
            } else {
                var id_selected = "";
            }

            Object.keys(this.searchParams).forEach((key) => {
                if (this.searchParams[key] === null) {
                    delete this.searchParams[key];
                }
            });
            var queryString = Object.keys(this.searchParams)
                .map((key) => key + "=" + this.searchParams[key])
                .join("&");
            console.log(queryString);
            window.open(`${this.printExcel}?${queryString}${id_selected}`);
        },
        async printWarta($x) {

            const x = this.checkSelect.map((e) => e.id);
            const y = this.checkSelect.map((e) => e.notis_id);
            // console.log(`${this.printUrl}?notis_id=[${y}]`);
            const w= $x;
            window.open(`${this.urlWarta}?notis_id=[${y}]&jabatan=${w}`, "_blank");
        },
    },
};
</script>
